// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest } from "rxjs";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Llama-MainLayoutHeader',
    templateUrl: './MainLayoutHeader.html',
    styleUrls: ['./MainLayoutHeader.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MainLayoutHeader extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Llama.MainLayoutHeader';
    $isDialog = false;
    $Modules = $Modules;
    Llama = Llama;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    readonly screen =
        ((component: typeof this) => {
            return {

            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })

    }

    async handler_ButtonBlock_37_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    await Sys.Process.unassignTask(Sys.Process.currentTaskTokenId)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_38_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {

                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_LinkBlock_17_click_toggleLogin_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_toggleLogin($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_LinkBlock_20_click_toggleLogin_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_toggleLogin($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }

    async action_toggleLogin($event?: any) {
        const { app, screen, output } = this
        {
            $event.preventDefault()
            if (Sys.User.currentUser) {
                await Sys.User.logout()
            }
            const { pathname, search, hash } = window.location
            const url = pathname + search + hash
            window.location.assign(`/studio/login?redirect=${encodeURIComponent(url)}`)
        }
    }
}
